module.exports = __webpack_public_path__ + "img/returned.6282189a.svg";